import { Component, Input, OnInit } from '@angular/core';
import { Scorecard, ScorecardDisplayType, ScorecardQuery, ScorecardService } from '@fgb/core';
import { firstValueFrom, Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ScorecardDescriptionComponent } from '../scorecard-description/scorecard-description.component';

@Component({
  selector: 'fgbcl-scorecard-list-view',
  templateUrl: './scorecard-list-view.component.html',
  styleUrls: ['./scorecard-list-view.component.scss'],
})
export class ScorecardListViewComponent implements OnInit {
  scorecard$: Observable<Scorecard[]>;
  scorecardDisplayType = ScorecardDisplayType;
  sharedScorecardId: any;
  openOnInitScorecard: number;
  scoreCardExpired: boolean = false;
  scorecardSubscription: Subscription | undefined;
  @Input() icon: string = 'info';
  @Input() confettiColors: string[];
  @Input() showPlaceholder: boolean = false;
  @Input() isSponsorInBody: boolean = false;
  constructor(
    private offcanvasService: NgbOffcanvas,
    private scorecardQuery: ScorecardQuery,
    private scorecardService: ScorecardService,
    private route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    await firstValueFrom(this.scorecardService.fetchScorecards());
    this.scorecard$ = this.scorecardQuery.selectAllScorecardSorted();
    this.sharedScorecardId = this.route.snapshot.paramMap.get('scorecardId') ?? null;
    if (this.sharedScorecardId && (await this.checkIfScorecardInList(this.sharedScorecardId))) {
      if (window.innerWidth > 576) {
        this.openModal(this.sharedScorecardId);
      }
    }
  }

  async checkIfScorecardInList(scorecardId: number): Promise<boolean> {
    try {
      const scorecards = await firstValueFrom(this.scorecard$);
      const exists = scorecards.some((item) => item.ScorecardId == scorecardId);
      return exists;
    } catch (error) {
      return false;
    }
  }

  ngOnDestroy(): void {
    if (this.scorecardSubscription) {
      this.scorecardSubscription.unsubscribe();
    }
  }
  openModal(id: any) {
    const offcanvasRef = this.offcanvasService.open(ScorecardDescriptionComponent, {
      position: 'bottom',
      panelClass: 'scorecard-offcanvas-content',
    });
    offcanvasRef.componentInstance.confettiColors = this.confettiColors;
    offcanvasRef.componentInstance.scorecardId = id;
    offcanvasRef.componentInstance.isSponsorInBody = this.isSponsorInBody;
  }
}
